/* EU-Gewährleistung & GARAN-Label (DVO (EU) 2025/1960) – Markup: snippets/eu-guarantee-labels.liquid */

if (!customElements.get('eu-guarantee-labels')) {
  customElements.define('eu-guarantee-labels', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const btn = this.querySelector('[data-eu-open]');
      this.dialog = this.querySelector('dialog');
      this.hasGaran = Boolean(this.dialog.dataset.garanSrc);

      btn.addEventListener('click', () => this.open());
      // Großes Label vorladen, sobald Interesse erkennbar ist (lazy-Bilder im geschlossenen Dialog laden sonst erst beim Öffnen)
      const preload = () => this.dialog.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
      ['pointerenter', 'focus', 'touchstart'].forEach((evt) => btn.addEventListener(evt, preload, { once: true, passive: true }));

      this.dialog.querySelector('[data-eu-close]').addEventListener('click', () => this.dialog.close());
      // Klick auf den Backdrop schließt
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });

      this.makeIdsUnique();
      if (this.hasGaran) this.watchVariant();
    }

    // Auf der Warenkorbseite existieren Drawer- und Seiten-Warenkorb gleichzeitig (gleiches Markup aus cart-form) –
    // daher eindeutige IDs vergeben, damit aria-labelledby auf den eigenen Titel zeigt
    makeIdsUnique() {
      const id = `eu-dialog-${Math.random().toString(36).slice(2, 9)}`;
      const title = this.dialog.querySelector('.eu-labels__dialog-title');
      this.dialog.id = id;
      this.querySelector('[data-eu-open]').dataset.euOpen = id;
      if (title) {
        title.id = `${id}-title`;
        this.dialog.setAttribute('aria-labelledby', title.id);
      }
    }

    // Model identifier = SKU der gewählten Variante. Shopify.OptionSelectors setzt den Wert des
    // Varianten-Selects nach jeder Optionsänderung, daher nach jedem change-Event neu auslesen.
    watchVariant() {
      const skuData = this.querySelector('[data-eu-variant-skus]');
      try {
        this.skus = skuData ? JSON.parse(skuData.textContent) : {};
      } catch (e) {
        console.error('eu-guarantee-labels: SKU-Daten nicht lesbar', e);
        this.skus = {};
      }
      const sync = () => setTimeout(() => {
        const select = document.getElementById(this.dataset.variantSelect);
        if (select) this.setModel(this.skus[select.value]);
      });
      document.addEventListener('change', sync);
      document.addEventListener('variantChange', sync);
    }

    setModel(sku) {
      const model = sku || this.dialog.dataset.garanFallback;
      if (model === this.dialog.dataset.garanModel) return;
      this.dialog.dataset.garanModel = model;
      if (this.modelText) this.writeModel();
    }

    open() {
      this.dialog.showModal();
      this.dialog.querySelector('.eu-labels__dialog-body').scrollTo(0, 0);
      // Textbreite lässt sich nur im sichtbaren Dialog messen – daher beim Öffnen neu schreiben
      if (this.hasGaran) this.modelText ? this.writeModel() : this.loadGaran();
    }

    async loadGaran() {
      const dialog = this.dialog;
      const target = dialog.querySelector('[data-garan-target]');
      if (target.childElementCount) return;
      const res = await fetch(dialog.dataset.garanSrc);
      target.innerHTML = await res.text();
      const svg = target.querySelector('svg');
      svg.setAttribute('role', 'img');
      // Übersetzter Text aus products.eu_labels.garan_label – %MODEL% wird durch die aktuelle SKU ersetzt
      svg.setAttribute('aria-label', dialog.dataset.garanLabel.replace('%MODEL%', dialog.dataset.garanModel));

      // Nur die laut DVO (EU) 2025/1960 Anhang II editierbaren Felder befüllen
      const texts = [...svg.querySelectorAll('text')];
      const find = (match) => texts.find((t) => t.textContent.trim() === match);
      const years = find('XX');
      const brand = find('Brand/Trademark');
      this.modelText = find('Model identifier');
      if (years) years.textContent = dialog.dataset.garanYears;
      if (brand) brand.textContent = dialog.dataset.garanBrand;
      if (this.modelText) {
        // Modellkennung rechtsbündig an der Trennlinie ausrichten, damit lange SKUs nicht überlaufen
        this.modelText.setAttribute('transform', 'translate(262.97 74.52)');
        this.modelText.setAttribute('text-anchor', 'end');
        await document.fonts.ready;
        this.writeModel();
      }
    }

    writeModel() {
      const el = this.modelText;
      const maxWidth = 150;
      el.removeAttribute('textLength');
      el.removeAttribute('lengthAdjust');
      el.textContent = this.dialog.dataset.garanModel;
      el.ownerSVGElement.setAttribute('aria-label', this.dialog.dataset.garanLabel.replace('%MODEL%', this.dialog.dataset.garanModel));
      // Lange Werte stauchen statt in "Brand/Trademark" hineinlaufen zu lassen
      if (el.getComputedTextLength() > maxWidth) {
        el.setAttribute('textLength', maxWidth);
        el.setAttribute('lengthAdjust', 'spacingAndGlyphs');
      }
    }
  });
}
